import {
	DownloadOutlined,
	OrderedListOutlined,
	PlusOutlined,
} from "@ant-design/icons";
import { Button, Space } from "antd";
import type React from "react";

export interface EventOccasionsActionsProps {
	primaryColor?: string;
	onRegisterEvent?: () => void;
	onCreateEvent?: () => void;
	onEditDisplayOrder?: () => void;
	onDownloadCSV?: () => void;
}

export const EventOccasionsActions: React.FC<EventOccasionsActionsProps> = ({
	primaryColor = "#99CA29",
	onRegisterEvent,
	onCreateEvent,
	onEditDisplayOrder,
	onDownloadCSV,
}) => {
	const buttonStyle = {
		backgroundColor: primaryColor,
		borderColor: primaryColor,
	};

	return (
		<Space>
			<Button
				type="primary"
				icon={<PlusOutlined />}
				onClick={() => {
					if (onCreateEvent) {
						onCreateEvent();
					} else if (onRegisterEvent) {
						onRegisterEvent();
					}
				}}
				style={buttonStyle}
			>
				イベント登録
			</Button>
			<Button
				type="primary"
				icon={<OrderedListOutlined />}
				onClick={onEditDisplayOrder}
				style={buttonStyle}
			>
				イベント表示順編集
			</Button>
			{/* 
			<Button
				type="primary"
				icon={<DownloadOutlined />}
				onClick={onDownloadCSV}
				style={buttonStyle}
			>
				予約リスト CSV
			</Button>
			*/}
		</Space>
	);
};
